export const DEFAULT_CURRENCY_TO = 'BTC';
export const DEFAULT_CURRENCY_FROM = 'USD';

export const PREDEFINED_CURRENCIES_FROM_LIST = [DEFAULT_CURRENCY_FROM, 'EUR', 'GBP'];
export const PREDEFINED_CURRENCIES_TO_LIST = [
  DEFAULT_CURRENCY_TO,
  'BTC-TESTNET',
  'ETH',
  'ETH-ROPSTEN',
  'USDT',
  'USDT-TRC20',
  'USDC',
  'BNBSC',
  'BNBSC-TESTNET',
];

export const DirectionEnum = {
  from: Symbol('from'),
  to: Symbol('to'),
};

export const ExchangeFormErrorCodes = {
  MIN_AMOUNT_ERROR_CODE: 'd20d4269-5e95-4234-9e4b-64e3279017b6',
  MAX_AMOUNT_ERROR_CODE: 'b11b0290-29db-4520-83e6-2d902b4a89c1',
};